// eslint-disable-next-line import/no-unresolved
import Keycloak from "keycloak-js";

const keycloakConfig = {
	url: window.env.REACT_APP_KEYCLOAK_URL,
	realm: window.env.REACT_APP_KEYCLOAK_REALM,
	clientId: window.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
